export default "__VITE_ASSET__3R2KHPyz__"